import { Suspense, lazy } from "react";

const Dex_list = lazy(() => import("./components/Dex_list"));

export function DexDashbord(params:{DeliveryPlant:string|""})  {
    return (<>
        <Suspense fallback={'Loading'}>
            <Dex_list DeliveryPlant = {params.DeliveryPlant}/>
        </Suspense>
    </>);
}